import type { LineupSlotChangeMeta } from '../../depth-chart/BaseballLineupGrid';

/** Compact batting-order draft slots after clearing one spot (later players shift up). */
export function compactGameLineupDraft(draft: (string | null)[], clearedOrder: number): (string | null)[] {
  const clearedIdx = clearedOrder - 1;
  const ids: string[] = [];
  for (let i = 0; i < draft.length; i++) {
    if (i === clearedIdx) continue;
    const id = draft[i];
    if (id) ids.push(id);
  }
  const len = Math.max(draft.length, 9);
  const out: (string | null)[] = Array(len).fill(null);
  ids.forEach((id, idx) => {
    out[idx] = id;
  });
  return out;
}

/** Same swap / clear semantics as Depth Chart batting grid, for game lineup drafts. */
export function applyGameLineupDraftChange(
  prev: (string | null)[],
  order: number,
  playerId: string | null,
  meta?: LineupSlotChangeMeta
): (string | null)[] {
  if (meta?.compactAfterClear && playerId === null) {
    return compactGameLineupDraft(prev, order);
  }

  const draft = [...prev];
  while (draft.length < order) draft.push(null);

  const getPidAt = (o: number): string | null => draft[o - 1] ?? null;

  const findOrderForPlayer = (pid: string): number | null => {
    for (let i = 0; i < draft.length; i++) {
      if (draft[i] === pid) return i + 1;
    }
    return null;
  };

  if (playerId === null) {
    draft[order - 1] = null;
    return draft;
  }

  const currentOrder = findOrderForPlayer(playerId);
  const existingAtTarget = getPidAt(order);

  if (existingAtTarget && existingAtTarget !== playerId) {
    if (currentOrder != null) draft[currentOrder - 1] = existingAtTarget;
    draft[order - 1] = playerId;
  } else if (!existingAtTarget) {
    if (currentOrder != null) draft[currentOrder - 1] = null;
    draft[order - 1] = playerId;
  }

  return draft;
}
